export enum TaskEvaRoute {
  Root = "/",
  AssetInput = "/assets",
  AssetOutput = "/output",
  CommitOverview = "/commitoverview",
  QRCodeOnly = "/qrcodeonly",
  BillPage = "/bill-page",
  Material = "/material",
  Render = "/render",
  Analysis = "/analysis",
  Setting = "/user/setting",
  Message = "/message",
  Center = "/message/center",
  JobConfig = "/message/jobConfig",
  BillConfig = "/message/billConfig",
  CapitalConfig = "/message/capitalConfig",
  Statistics = "/statistics",
  Desktop = "/desktop",
}

export const TaskEvaRouteList = Object.values(TaskEvaRoute);
